export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=24361e8c&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/list.vue?vue&type=template&id=24361e8c&
// module id = 930
// module chunks = 0